import { URL } from '../../variables';
export async function correctionReportRequest(token, facultyId, suffix, method = 'GET', data) {
  const response = await fetch(`${URL}api/faculdade/dashboard/${facultyId}/correcoes${suffix}`, {
    method, headers: { Accept: 'application/json', Authorization: `Bearer ${token}`, ...(data ? { 'Content-Type': 'application/json' } : {}) }, body: data ? JSON.stringify(data) : undefined,
  });
  const result = await response.json().catch(() => null);
  if (!response.ok || !result) { const error = new Error(result?.errors ? Object.values(result.errors).flat().join(' ') : result?.message || 'Não foi possível carregar as correções.'); error.status = response.status; throw error; }
  return result;
}
export function reportQuery(filters) { const params = new URLSearchParams(); Object.entries(filters).forEach(([key, value]) => { if (value !== '' && value != null) params.set(key, value); }); return params.toString(); }
